"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TBCarousel = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("@storyblok/react");
var framer_motion_1 = require("framer-motion");
var helpers_1 = require("../../helpers");
var react_2 = require("react");
var fi_1 = require("react-icons/fi");
var react_use_measure_1 = __importDefault(require("react-use-measure"));
var CARD_WIDTH = 350;
var CARD_HEIGHT = 300;
var MARGIN = 20;
var CARD_SIZE = CARD_WIDTH + MARGIN;
var BREAKPOINTS = {
    sm: 640,
    lg: 1024,
};
function TBCarousel(_a) {
    var _b, _c;
    var blok = _a.blok;
    var _d = __read((0, react_use_measure_1.default)(), 2), ref = _d[0], width = _d[1].width;
    var _e = __read((0, react_2.useState)(0), 2), offset = _e[0], setOffset = _e[1];
    var CARD_BUFFER = width > BREAKPOINTS.lg ? 3 : width > BREAKPOINTS.sm ? 2 : 1;
    var CAN_SHIFT_LEFT = offset < 0;
    var CAN_SHIFT_RIGHT = Math.abs(offset) <
        CARD_SIZE * ((((_b = blok.carousel_block) === null || _b === void 0 ? void 0 : _b.length) || 0) - CARD_BUFFER);
    var shiftLeft = function () {
        if (!CAN_SHIFT_LEFT) {
            return;
        }
        setOffset(function (pv) { return (pv += CARD_SIZE); });
    };
    var shiftRight = function () {
        if (!CAN_SHIFT_RIGHT) {
            return;
        }
        setOffset(function (pv) { return (pv -= CARD_SIZE); });
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({}, (0, react_1.storyblokEditable)(blok), { ref: ref, children: (0, jsx_runtime_1.jsxs)("div", { className: "py-4 ".concat((0, helpers_1.topiaBlockClassnames)(blok)), children: [(0, jsx_runtime_1.jsx)("h3", { className: "py-4 text-center text-3xl", children: blok.title }), (0, jsx_runtime_1.jsxs)("div", { className: "relative p-4", children: [(0, jsx_runtime_1.jsx)("div", { className: "mx-auto max-w-6xl", children: (0, jsx_runtime_1.jsx)(framer_motion_1.motion.div, { animate: {
                                    x: offset,
                                }, className: "flex", children: (_c = blok.carousel_block) === null || _c === void 0 ? void 0 : _c.map(function (item) {
                                    return (0, jsx_runtime_1.jsx)(Card, __assign({}, item), item.id);
                                }) }) }), (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { initial: false, animate: {
                                        x: CAN_SHIFT_LEFT ? "0%" : "-100%",
                                    }, className: "absolute left-0 top-[80%] z-30 rounded-r-xl bg-slate-100/30 p-2 pl-2 text-3xl text-white backdrop-blur-sm transition-[padding] hover:pl-3", onClick: shiftLeft, children: (0, jsx_runtime_1.jsx)(fi_1.FiChevronLeft, {}) }), (0, jsx_runtime_1.jsx)(framer_motion_1.motion.button, { initial: false, animate: {
                                        x: CAN_SHIFT_RIGHT ? "0%" : "100%",
                                    }, className: "absolute right-0 top-[80%] z-30 rounded-l-xl bg-slate-100/30 p-2 pr-2 text-3xl text-white backdrop-blur-sm transition-[padding] hover:pr-3", onClick: shiftRight, children: (0, jsx_runtime_1.jsx)(fi_1.FiChevronRight, {}) })] })] })] }) })));
}
exports.TBCarousel = TBCarousel;
var Card = function (props) {
    var _a;
    console.log((_a = props.background_image) === null || _a === void 0 ? void 0 : _a.filename);
    return ((0, jsx_runtime_1.jsx)("div", { title: props.background_image ? props.background_image.alt : "", className: "relative  shrink-0 cursor-pointer rounded-2xl bg-topia-gray bg-contain bg-top bg-no-repeat shadow-md transition-all hover:scale-[1.015] hover:shadow-xl", style: {
            width: CARD_WIDTH,
            height: CARD_HEIGHT,
            marginRight: MARGIN,
            backgroundImage: "url(".concat(props.background_image ? props.background_image.filename : "", ")"),
        }, children: (0, jsx_runtime_1.jsxs)("div", { className: "absolute inset-0 z-20 rounded-2xl bg-topia-black p-6 text-white transition-[backdrop-filter] hover:backdrop-blur-sm", children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex flex-row items-center gap-4", children: [(0, jsx_runtime_1.jsx)("img", { width: 50, className: "rounded-full", src: "".concat(props.headshot.filename), alt: props.headshot.alt }), (0, jsx_runtime_1.jsxs)("span", { className: "text-md font-bold uppercase text-future-blue", children: [props.name, " - ", props.side_hustle] })] }), (0, jsx_runtime_1.jsx)("p", { className: "my-2 text-md font-bold", children: props.stat_1 }), (0, jsx_runtime_1.jsx)("div", { 
                    // className={`${topiaBlockClassnames(blok)}`}
                    className: " text-sm text-white", dangerouslySetInnerHTML: {
                        __html: (0, helpers_1.topiaRichText)(props.case_summary),
                    } })] }) }));
};
